import { render, staticRenderFns } from "./ColumnDescription.vue?vue&type=template&id=7a9f7666&scoped=true"
import script from "./ColumnDescription.vue?vue&type=script&lang=js"
export * from "./ColumnDescription.vue?vue&type=script&lang=js"
import style0 from "./ColumnDescription.vue?vue&type=style&index=0&id=7a9f7666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f7666",
  null
  
)

export default component.exports